import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {

	private history: string[];

	constructor(private router: Router, private location: Location) {
		const histFromSessionStorage = sessionStorage.getItem('navHistory');
		this.history = histFromSessionStorage ? JSON.parse(histFromSessionStorage) : [];
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (this.history.length === 0 || this.history[this.history.length - 1] !== event.urlAfterRedirects) {
					this.history.push(event.urlAfterRedirects);
					sessionStorage.setItem('navHistory', JSON.stringify(this.history));
				}
			}
		});
	}

	back(): void {
		if (this.history.length > 0) {
			this.history.pop();
			sessionStorage.setItem('navHistory', JSON.stringify(this.history));
			this.location.back();
		} else {
			sessionStorage.setItem('navHistory', JSON.stringify(this.history));
			this.router.navigateByUrl('/');
		}
	}

	navigateToHome() {
		this.router.navigate(['']);
	}

	navigateToAbout() {
		this.router.navigate(['about-us']);
	}

	navigateToBlog() {
		this.router.navigate(['blog']);
	}

	navigateToQuote() {
		this.router.navigate(['/quote-app/quote']);
	}

	navigateToBenefits() {
		this.router.navigate(['benefits']);
	}

	navigateToInsured() {
		this.router.navigate(['insured']);
	}

	navigateToLogin() {
		this.router.navigate(['login']);
	}


	scrollTo(elementId: string): void {
		const element = document.getElementById(elementId);
		if (element) {
			element.scrollIntoView({ behavior: "smooth",
			block: 'center',
			inline: 'center' });
		}
	}
}
